import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Label } from "@/components/ui/label";

export const useAffiliations = () => {
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/denominations").then((r) => setD(r.data)); }, []);
  return d;
};

export const AffiliationPicker = ({ value, onChange }) => {
  const d = useAffiliations();
  return (
    <div className="space-y-2" data-testid="affiliation-picker">
      <Label>What best describes your church's religious affiliation?</Label>
      <div className="flex flex-wrap gap-2">
        {d && Object.entries(d.affiliations).map(([k, label]) => (
          <button type="button" key={k} onClick={() => onChange(k)} data-testid={`affiliation-${k}`}
            className={`text-sm rounded-full px-4 py-2 border transition-colors ${value === k ? "bg-navy text-white border-navy" : "border-line text-navy hover:border-teal"}`}>{label}</button>
        ))}
      </div>
      <p className="text-xs text-muted-ink">This sets your starting ministry library. You can rename, hide or add ministries anytime.</p>
    </div>
  );
};
